import { render, staticRenderFns } from "./Sucesso.vue?vue&type=template&id=b587d366&"
import script from "./Sucesso.vue?vue&type=script&lang=js&"
export * from "./Sucesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports